/**
 * @desc 保存移除货存报告mq
 */
const URL = "/rantion-plat-data-flow";
import http, { updateResponse } from "@/http";
export function request(
  body: defs.platDataFlow.AmazonReportRemovalShipmentRequestParamsDto,
  options?: any,
) {
  return updateResponse(
    http(URL + `/mqPush/saveRemovalShipmentMq`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
